"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class Team extends Parse.Object {
    constructor(attributes) {
        super('Team', attributes);
    }
    get name() {
        return this.get('name');
    }
    set name(value) {
        this.set('name', value);
    }
    get emojiIcon() {
        return this.get('emojiIcon');
    }
    set emojiIcon(value) {
        this.set('emojiIcon', value);
    }
    get retailer() {
        return this.get('retailer');
    }
    set retailer(value) {
        this.set('retailer', value);
    }
    get users() {
        return this.get('users');
    }
    set users(value) {
        this.set('users', value);
    }
    get supervisors() {
        return this.get('supervisors');
    }
    set supervisors(value) {
        this.set('supervisors', value);
    }
    get greetingMessage() {
        return this.get('greetingMessage');
    }
    set greetingMessage(value) {
        this.set('greetingMessage', value);
    }
    get isSequentialEnabled() {
        return this.get('isSequentialEnabled');
    }
    set isSequentialEnabled(value) {
        this.set('isSequentialEnabled', value);
    }
    get sequenceUsers() {
        return this.get('sequenceUsers');
    }
    set sequenceUsers(value) {
        this.set('sequenceUsers', value);
    }
    /**
     * SLA to team handle the CSR
     */
    get slaTiming() {
        return this.get('slaTiming');
    }
    set slaTiming(value) {
        this.set('slaTiming', value);
    }
    /**
     * Rule to apply if the sla expires
     */
    get slaRule() {
        return this.get('slaRule');
    }
    set slaRule(value) {
        this.set('slaRule', value);
    }
    /**
     * defines a payment gateway integration to this team
     */
    get paymentGatewayIntegration() {
        return this.get('paymentGatewayIntegration');
    }
    set paymentGatewayIntegration(value) {
        this.set('paymentGatewayIntegration', value);
    }
    get paymentGatewayMundipagg() {
        return this.get('paymentGatewayMundipagg');
    }
    set paymentGatewayMundipagg(value) {
        this.set('paymentGatewayMundipagg', value);
    }
    get timeAccessRestriction() { return this.get("timeAccessRestriction"); }
    set timeAccessRestriction(value) { this.set("timeAccessRestriction", value); }
    get canonicalSearch() { return this.get('canonicalSearch'); }
    set canonicalSearch(value) { this.set('canonicalSearch', value); }
    get disabled() {
        return this.get('disabled');
    }
    set disabled(value) {
        this.set('disabled', value);
    }
    get totalActiveChats() { return this.get('totalActiveChats'); }
    set totalActiveChats(value) { this.set('totalActiveChats', value); }
}
exports.Team = Team;
Parse.Object.registerSubclass('Team', Team);
//# sourceMappingURL=Team.js.map